var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColouredTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2794 2.07765C17.2568 2.07833 17.2343 2.08023 17.2119 2.08335H11.4583C11.2329 2.08016 11.0233 2.19858 10.9096 2.39327C10.796 2.58796 10.796 2.82875 10.9096 3.02343C11.0233 3.21812 11.2329 3.33654 11.4583 3.33335H15.7829L9.34977 9.76645C9.18649 9.92321 9.12073 10.156 9.17783 10.375C9.23493 10.594 9.40597 10.7651 9.62499 10.8222C9.84401 10.8793 10.0768 10.8135 10.2336 10.6502L16.6667 4.21714V8.54168C16.6635 8.76708 16.7819 8.97673 16.9766 9.09036C17.1713 9.20399 17.412 9.20399 17.6067 9.09036C17.8014 8.97673 17.9198 8.76708 17.9167 8.54168V2.78729C17.9416 2.60528 17.8852 2.42153 17.7625 2.28484C17.6397 2.14816 17.4631 2.07239 17.2794 2.07765ZM5.20833 3.33335C3.48979 3.33335 2.08333 4.73981 2.08333 6.45835V14.7917C2.08333 16.5102 3.48979 17.9167 5.20833 17.9167H13.5417C15.2602 17.9167 16.6667 16.5102 16.6667 14.7917V10.625C16.6698 10.3996 16.5514 10.19 16.3567 10.0763C16.162 9.9627 15.9213 9.9627 15.7266 10.0763C15.5319 10.19 15.4135 10.3996 15.4167 10.625V14.7917C15.4167 15.8348 14.5848 16.6667 13.5417 16.6667H5.20833C4.1652 16.6667 3.33333 15.8348 3.33333 14.7917V6.45835C3.33333 5.41522 4.1652 4.58335 5.20833 4.58335H9.37499C9.60039 4.58654 9.81004 4.46812 9.92367 4.27343C10.0373 4.07874 10.0373 3.83795 9.92367 3.64327C9.81004 3.44858 9.60039 3.33016 9.37499 3.33335H5.20833Z",
    fill: "#FE8900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColouredTabIcon);
export default __webpack_public_path__ + "static/media/coloured-tab-icon.7a2d4683694bd2d95b5a67dd55787573.svg";
export { ForwardRef as ReactComponent };